import { Button } from '@mui/material';
import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { AUTHENTICATED_ROUTES } from '../../../resources/routes-constants';
import { useTranslation } from 'react-i18next';

const CreatePortfolioButton: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const onClick = () => {
        navigate(AUTHENTICATED_ROUTES.PORTFOLIO_CREATE_ROUTE);
    }

    return <Button endIcon={<AddIcon />} variant='contained' sx={{
        padding: "9px 16px",
        textTransform: "none",
        width: "100%",
        justifyContent: "space-between"
    }} onClick={onClick}>{t('DashboardCreatePortfolioBtn')}</Button>
}

export default CreatePortfolioButton;